import { useCallback } from 'react'
import { useAppDispatch } from '@/state'
import { FormStatusType } from '@/enums/form-status.enum'

import { setFormModeAction } from '@/state/ui/global/slices/index.slices'
import {
  GetPlayerTransactionsPayload,
  PlayerTransactionFilters,
  PlayerTransactionItem,
  XlsxPlayerTransactionType,
} from '@/state/player-transactions/models'
import { PlayerTransactionsActions } from '@/state/player-transactions/slices/index.slices'

import { getAllPlayerTransactionsThunk } from '@/state/player-transactions/thunks/get-all.thunk'
import { getFilterOptionsThunk } from '@/state/player-transactions/thunks/get-filter-options.thunk'
import { exportXlsxFile, removeEmptyProp } from '@/utils'
import { TableHeadCellPropsType } from '@/state/ui/global/models'

export const useTransactionsActions = () => {
  const dispatch = useAppDispatch()

  const getAllTransactions = async (
    filters: GetPlayerTransactionsPayload,
    headCells?: TableHeadCellPropsType<PlayerTransactionItem>[],
    fileName?: string,
    getFormattedRow?: (row: PlayerTransactionItem) => XlsxPlayerTransactionType,
  ) => {
    const newFilters = removeEmptyProp(filters)

    const resultAction = await dispatch(
      getAllPlayerTransactionsThunk({
        ...newFilters,
        xlsx: !!headCells,
      }),
    )

    if (
      getFormattedRow &&
      headCells &&
      getAllPlayerTransactionsThunk.fulfilled.match(resultAction)
    ) {
      exportXlsxFile(
        headCells,
        resultAction.payload.items.map((item) => getFormattedRow(item)),
        fileName,
      )
    }
  }

  const getFilterOptions = useCallback(
    () => dispatch(getFilterOptionsThunk()),
    [dispatch],
  )

  const setFormType = useCallback(
    (formMode: FormStatusType) => dispatch(setFormModeAction(formMode)),
    [dispatch],
  )

  const setTransactionsFilters = useCallback(
    (filters: PlayerTransactionFilters) =>
      dispatch(PlayerTransactionsActions.setTransactionFiltersAction(filters)),
    [dispatch],
  )

  const cleanTransactions = useCallback(
    () => dispatch(PlayerTransactionsActions.cleanTransactionsAction()),
    [dispatch],
  )

  return {
    getAllTransactions,
    getFilterOptions,
    setFormType,
    setTransactionsFilters,
    cleanTransactions,
  }
}
